import { render, staticRenderFns } from "./PublicationEditionCard.vue?vue&type=template&id=6d346a2a&"
import script from "./PublicationEditionCard.vue?vue&type=script&lang=js&"
export * from "./PublicationEditionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports